<div class="max-w-4xl mx-auto p-4 sm:p-6 space-y-6">
  <div class="flex items-center gap-3">
    <button class="rounded-lg border border-slate-200 px-3 py-1.5 text-sm text-slate-600 hover:bg-slate-50"
      (click)="cerrar.emit()">
      <i class="bi bi-arrow-left mr-1"></i>Volver
    </button>
    <h2 class="text-lg font-semibold text-slate-800">{{ flujo().nombre }}</h2>
  </div>

  <div class="flex items-center justify-between">
    <p class="text-sm text-slate-500">
      Cada paso responde a palabras clave y puede tener un menú de opciones.
    </p>
    <button class="rounded-lg bg-sky-600 px-4 py-2 text-sm font-medium text-white hover:bg-sky-700"
      (click)="abrirNuevo()">
      + Agregar paso
    </button>
  </div>

  @if (pasoEditando()) {
    <div class="rounded-xl border border-sky-200 bg-sky-50 p-5 space-y-4">
      <h3 class="text-sm font-semibold text-sky-800">
        {{ esNuevo() ? 'Nuevo paso' : 'Editar paso' }}
      </h3>

      <div>
        <label class="block text-xs text-slate-500 mb-1">Título (identifica el paso en la lista)</label>
        <input type="text" class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-500"
          placeholder="ej: Bienvenida, Soporte, Ventas..."
          [ngModel]="formTitulo()" (ngModelChange)="formTitulo.set($event)" />
      </div>

      <div>
        <label class="block text-xs text-slate-500 mb-1">Palabras clave (separadas por coma)</label>
        <input type="text" class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-500"
          placeholder="hola, buenos dias, info, ayuda"
          [ngModel]="formPalabras()" (ngModelChange)="formPalabras.set($event)" />
        <p class="text-[11px] text-slate-400 mt-1">Cuando alguien escribe alguna de estas palabras, este paso se activa.</p>
      </div>

      <div>
        <label class="block text-xs text-slate-500 mb-1">Mensaje de respuesta</label>
        <textarea class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-500" rows="3"
          placeholder="Escribe el mensaje que se enviará..."
          [ngModel]="formMensaje()" (ngModelChange)="formMensaje.set($event)"></textarea>
      </div>

      <div class="border-t border-sky-200 pt-4">
        <label class="block text-xs text-slate-500 mb-2 font-medium">Archivo adjunto (opcional)</label>
        <p class="text-[11px] text-slate-400 mb-2">Sube una imagen o PDF para enviar junto con el mensaje.</p>
        <div class="flex items-center gap-2">
          <input type="file" accept="image/*,.pdf" class="hidden" #fileInput (change)="onFileSelected($event)" />
          <button class="rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-600 hover:bg-slate-50"
            [disabled]="subiendoArchivo()" (click)="fileInput.click()">
            <i class="bi bi-upload mr-1"></i>{{ subiendoArchivo() ? 'Subiendo...' : 'Subir archivo' }}
          </button>
          @if (formMediaUrl()) {
            <span class="text-xs text-green-600 flex items-center gap-1">
              <i class="bi bi-check-circle"></i> {{ formMediaNombre() }}
              <button class="text-red-400 hover:text-red-600 ml-1" (click)="formMediaUrl.set(''); formMediaNombre.set('')">
                <i class="bi bi-x"></i>
              </button>
            </span>
          } @else {
            <span class="text-xs text-slate-400">Ningún archivo seleccionado</span>
          }
        </div>
      </div>

      <div class="border-t border-sky-200 pt-4">
        <div class="flex items-center justify-between mb-2">
          <label class="text-xs text-slate-500 font-medium">Opciones del menú (opcional)</label>
          <span class="text-[11px] text-slate-400">El usuario responde con el número</span>
        </div>

        <div class="flex flex-wrap gap-2 mb-2">
          <input type="text" class="w-14 rounded-lg border border-slate-300 px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-500"
            placeholder="N°" [ngModel]="formOpcionNumero()" (ngModelChange)="formOpcionNumero.set($event)"
            (keyup.enter)="agregarOpcion()" />
          <input type="text" class="flex-1 min-w-40 rounded-lg border border-slate-300 px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-500"
            placeholder="Texto (ej: Soporte técnico)" [ngModel]="formOpcionTexto()" (ngModelChange)="formOpcionTexto.set($event)"
            (keyup.enter)="agregarOpcion()" />
          <select class="w-32 rounded-lg border border-slate-300 px-2 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-sky-500"
            [ngModel]="formOpcionDestino()" (ngModelChange)="formOpcionDestino.set($event)">
            <option [ngValue]="0">Sin destino</option>
            @for (p of pasos(); track p.id) {
              <option [ngValue]="p.id">{{ p.titulo || 'Paso ' + (p.orden + 1) }}</option>
            }
          </select>
          <button class="rounded-lg bg-slate-100 px-3 py-2 text-sm text-slate-600 hover:bg-slate-200"
            (click)="agregarOpcion()">+</button>
        </div>

        @for (op of formOpciones(); track $index) {
          <div class="flex items-center gap-2 text-sm bg-white rounded-lg border border-slate-200 px-3 py-1.5">
            <span class="font-medium text-slate-600">{{ op.numero }}.</span>
            <span class="flex-1 text-slate-700">{{ op.texto }}</span>
            @if (op.paso_destino_id) {
              <span class="text-[11px] px-1.5 py-0.5 rounded bg-purple-50 text-purple-600">
                → {{ pasosPorId()[op.paso_destino_id] || 'Paso #' + op.paso_destino_id }}
              </span>
            }
            <button class="text-red-400 hover:text-red-600" (click)="quitarOpcion($index)">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        }
      </div>

      <div class="flex gap-2">
        <button class="rounded-lg bg-sky-600 px-4 py-2 text-sm text-white hover:bg-sky-700" (click)="guardar()">
          {{ esNuevo() ? 'Agregar' : 'Guardar' }}
        </button>
        <button class="rounded-lg border border-slate-300 px-4 py-2 text-sm text-slate-600 hover:bg-slate-50"
          (click)="cerrarFormulario()">Cancelar</button>
      </div>
    </div>
  }

  @if (pasos().length === 0 && !pasoEditando()) {
    <div class="flex flex-col items-center gap-3 py-12 text-slate-400">
      <i class="bi bi-inbox text-4xl"></i>
      <p class="text-sm">Este flujo no tiene pasos.</p>
      <p class="text-xs">Agrega el primer paso para empezar.</p>
    </div>
  } @else if (pasos().length > 0) {
    <div class="space-y-2">
      @for (paso of pasos(); track paso.id; let idx = $index) {
        <div class="rounded-lg border border-slate-200 bg-white p-4 hover:border-sky-200 transition-colors">
          <div class="flex items-start gap-3">
            <div class="flex flex-col items-center gap-1 pt-1">
              <button class="text-slate-300 hover:text-slate-500 text-xs leading-none"
                [class.invisible]="idx === 0" (click)="moverPaso(idx, 'arriba')">
                <i class="bi bi-chevron-up"></i>
              </button>
              <span class="text-xs font-medium text-slate-400 w-6 text-center">{{ idx + 1 }}</span>
              <button class="text-slate-300 hover:text-slate-500 text-xs leading-none"
                [class.invisible]="idx === pasos().length - 1" (click)="moverPaso(idx, 'abajo')">
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>

            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2 flex-wrap">
                @if (paso.titulo) {
                  <span class="font-medium text-sm text-slate-700">{{ paso.titulo }}</span>
                }
                @if (paso.contenido?.palabras_clave?.length) {
                  <span class="text-[10px] px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 font-medium">
                    🔑 {{ paso.contenido!.palabras_clave!.join(', ') }}
                  </span>
                }
                @if (paso.contenido?.opciones?.length) {
                  <span class="text-[10px] px-2 py-0.5 rounded-full bg-purple-50 text-purple-700 font-medium">
                    📋 {{ paso.contenido!.opciones!.length }} opciones
                  </span>
                }
                @if (paso.contenido?.media?.url) {
                  <span class="text-[10px] px-2 py-0.5 rounded-full bg-rose-50 text-rose-700 font-medium">
                    📎 {{ paso.contenido!.media!.tipo === 'image' ? 'Imagen' : 'Documento' }}
                  </span>
                }
              </div>
              @if (contenidoResumen(paso)) {
                <p class="text-xs text-slate-400 mt-1 truncate">{{ contenidoResumen(paso) }}</p>
              }
            </div>

            <div class="flex items-center gap-1 shrink-0">
              <button class="rounded p-1.5 text-slate-400 hover:text-sky-600 hover:bg-sky-50"
                (click)="abrirEditar(paso)">
                <i class="bi bi-pencil text-sm"></i>
              </button>
              <button class="rounded p-1.5 text-slate-400 hover:text-red-600 hover:bg-red-50"
                (click)="eliminarPaso(paso)">
                <i class="bi bi-trash text-sm"></i>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
